import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomHeartIcon from "@tSurya/Icons/CustomHeartIcon";
import AddToListIcon from "@tSurya/MobiusOverrides/Icons/AddToListIcon";
import ProductAddToListLink from "@tSurya/Overrides/Components/ProductAddToListLink";
// import AddToListIcon from "@tSurya/MobiusOverrides/Icons/AddToListIcon";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: InjectableCss;
    button: InjectableCss;
    heartIcon?: InjectableCss;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    link: {
        css: css`
            span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                text-align: center;
            }
        `,
    },
    button: {
        css: css`
            margin-left: 18px;
            > button {
                width: 84px;
                height: 24px;
            }
        `,
    },
    heartIcon: {
        css: css`
            margin-top: 3px;
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    // if (!product.canAddToWishlist && !variantSelectionCompleted) {
    //     return null;
    // }

    if (product.productNumber.toLowerCase().endsWith("-cstd") || product.productNumber.toLowerCase().endsWith("-cexp") || product.productNumber.toLowerCase().endsWith("-custom")) {
        return null;
    }

    return (
        <StyledWrapper>
            <ProductAddToListLink fromPDP={true} labelOverride="Add to Project" data-test-selector="productDetails_addToList" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
